module.exports = __webpack_public_path__ + "static/media/diagram_04.820b5c9c.svg";